import { useCallback } from 'react';
import { useNavigate } from 'react-router';

import routes from '@/assets/constants/routes-no.ts';
import type { CompetitionWithConfig } from '@/lib/api/requests.ts';

export const useGoToActiveCompetition = (activeCompetition: CompetitionWithConfig | undefined) => {
  const navigate = useNavigate();

  return useCallback(() => {
    if (activeCompetition) {
      return navigate(activeCompetition.config.href);
    } else {
      return navigate(routes.COMPETITION_WINNERS);
    }
  }, [activeCompetition, navigate]);
};
